import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editForm", "countLabel", "hiddenInputs"]

  startEdit(event) {
    event.preventDefault()
    if (this.hasDisplayTarget) this.displayTarget.classList.add("hidden")
    this.editFormTarget.classList.remove("hidden")
  }

  cancelEdit() {
    if (this.hasDisplayTarget) this.displayTarget.classList.remove("hidden")
    this.editFormTarget.classList.add("hidden")
  }

  escapeEdit(event) {
    if (event.key === "Escape") {
      this.cancelEdit()
      this.dispatch("cancelled")
    }
  }

  toggleState(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const state = btn.dataset.state
    const isSelected = btn.getAttribute("aria-pressed") === "true"

    if (isSelected) {
      btn.setAttribute("aria-pressed", "false")
      const input = this.hiddenInputsTarget.querySelector(
        `input[value="${state}"]`
      )
      if (input) input.remove()
    } else {
      btn.setAttribute("aria-pressed", "true")
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "market[state_codes][]"
      input.value = state
      this.hiddenInputsTarget.appendChild(input)
    }

    this.updateCount()
  }

  updateCount() {
    if (!this.hasCountLabelTarget) return
    const count = this.hiddenInputsTarget.querySelectorAll("input").length
    this.countLabelTarget.textContent = count
  }
}
